import { FC } from "react";
import CalendarIcon from "../icons/calendar";
import { Control, Controller, UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import moment from "moment";

type Inputs = any;

interface Props {
  register: UseFormRegister<Inputs>;
  control: Control<any>;
  errors: any;
  name: string;
  placeholder: string;
  label: string;
  type: string;
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
  date: string;
  setDate: (date: string) => void;
}

const FormDateInput: FC<Props> = ({
  register,
  errors,
  control,
  name,
  placeholder,
  label,
  disabled,
  printEnabled = false,
  date,
  setDate,
}) => {
  const { t } = useTranslation();
  function formatDate(date: any) {
    return moment(date).format("YYYY-MM-DD");
  }
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0">
      <label htmlFor={name} className="font-normal text-xl text-[#1E408E]">
        <Trans t={t}>{label}</Trans>
      </label>
      <div className="pr-10 grid">
        <div className="flex flex-row justify-evenly gap-x-4">
          <div className="relative flex items-center pr-2  border border-[#8692A6] rounded w-full">
            <Controller
              control={control}
              name={name}
              render={({ field }) => (
                <DatePicker
                  filterDate={(d) => {
                    return new Date() > d;
                  }}
                  selectsRange={false}
                  onChange={(update) => {
                    field.onChange(formatDate(update));
                    setDate(formatDate(update) || formatDate(new Date()));
                  }}
                  placeholderText={placeholder}
                  selected={new Date(date)}
                  dateFormat={"YYYY-MM-DD"}
                  value={formatDate(date)}
                  isClearable={false}
                  disabled={disabled}
                  className="w-full relative z-10 bg-transparent focus:border-none p-3 focus:ring-0 focus-within:outline-none border-none placeholder:text-gray-400"
                />
              )}
            />

            <CalendarIcon />
          </div>
          {printEnabled && (
            <input type="checkbox" {...register(`print${name}`)} defaultChecked id={`${name}`} />
          )}
        </div>
        {errors[name] && (
          <p className="text-red-500 text-xs">
            <Trans t={t}>{errors[name]?.message}</Trans>
          </p>
        )}
      </div>
    </div>
  );
};

export default FormDateInput;
